import { FilterValue } from '../types/index';
import { decodeData } from '../../../utils/encodeUtils';
import Filters from '../Filters';

export const initializeFiltersFromURL = (restDefaultFilterValue?: FilterValue[]): FilterValue[] => {
  const urlParams = new URLSearchParams(window.location.search);
  const encodedFilters = urlParams.get('f');

  let urlFilters: FilterValue[] = [];
  if (encodedFilters) {
    try {
      urlFilters = decodeData(encodedFilters);
    } catch (error) {
      // Silent error handling - use empty array if decoding fails
    }
  }

  const baseFilters = Filters.filter((f: any) => f).map((f: any) => ({ ...f, value: f.value || '' }));
  const propFilters = Array.isArray(restDefaultFilterValue) ? restDefaultFilterValue : [];

  if (urlFilters.length > 0) {
    return [...baseFilters, ...urlFilters.map(f => ({ ...f, value: f.value || '' }))];
  }

  if (propFilters.length > 0) {
    return [...baseFilters, ...propFilters.map(f => ({ ...f, value: f.value || '' }))];
  }

  return baseFilters;
};

export const shouldShowRestrictionError = (
  restrictGridDisplay: boolean,
  restrictChemical: boolean,
  view: string,
  tab: string,
  isMapping?: boolean,
  mappingContent?: any,
): boolean => {
  return (
    (restrictGridDisplay && view === 'ALL') ||
    (restrictChemical && tab === 'CHEMICALS') ||
    (restrictChemical && view === 'CHEMICALS') ||
    (restrictChemical && isMapping && mappingContent?.tabSegment.includes('chem')) ||
    (restrictChemical && isMapping && mappingContent?.name === 'numberPmidsWithChemsIncludedInEvidence')
  );
};

// Re-export functions from SortFilterTables
export {
  getFiltersMap,
  getFilters,
  getSort,
  getMinFilterString,
  getMaxFilterString,
  getNumberFilter,
} from './SortFilterTables';

export function getSelectedRowsFromEnrichmentState<T = any>(
  rowData: T[],
  enrichmentRowSelection: Record<string, boolean>,
  getRowId: ((row: T, index: number) => string) | undefined,
): T[] {
  const getKey = getRowId ?? ((_: T, i: number) => String(i));
  return rowData.filter((row, index) => enrichmentRowSelection[getKey(row, index)]);
}

export function isRunEnrichmentEnabled(selectedCount: number): boolean {
  return selectedCount > 1;
}
